// Wrappers around native DOM operations to simplify testing

export const getCookies = () => document.cookie;

export const setCookie = str => (document.cookie = str);
